module.exports = __webpack_public_path__ + "img/7.a6731c5e.jpg";